import React from 'react';
import { Col, Row } from 'antd';
import SuccessIcon from '@BUP/assets/Images/Home/success_icon.png';
import TextIcon from '@BUP/assets/Images/Home/text_icon.png';
import GroupIcon from '@BUP/assets/Images/Home/group_icon.png';
import ClickIcon from '@BUP/assets/Images/Home/click_icon.png';
import DownloadIcon from '@BUP/assets/Images/Home/download_icon.png';
import { DataBupCard } from '@BUP/components';
import { useAuth } from '@BUP/hooks';
import { ECE, ASSISTANT, TEACHER, STUDENT, PARENT } from '@BUP/constants';
import GuiaOrientacion from '@BUP/assets/Documents/Data/guia_orientacion_toma_de_datos.pdf';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './data-bup-panel.module.css';

const DataBupPanel = ({ title }) => {
  const { user } = useAuth();
  const roleType = user?.roles.type;
  const [t] = useTranslation();
  return (
    <div>
      <Row>
        <Col>
          <h3 className={styles.container_title}>{title}</h3>
        </Col>
      </Row>
      <Row
        className={styles.container}
        type="flex"
        align="middle"
        justify="center"
      >
        {roleType === ECE && (
          <>
            <Col md={20} xxl={24}>
              <Link to="/data/instruments">
                <DataBupCard
                  alt="info"
                  icon={SuccessIcon}
                  text={t('pages.home.dataPanel.button1Text')}
                />
              </Link>
              <Link to="/data/tracking">
                <DataBupCard
                  alt="info"
                  icon={TextIcon}
                  text={t('pages.home.dataPanel.button2Text')}
                />
              </Link>
            </Col>
          </>
        )}
        {roleType === ASSISTANT || roleType === TEACHER ? (
          <Col md={20} xxl={24}>
            <Link to="/data/instruments">
              <DataBupCard
                alt="info"
                icon={GroupIcon}
                text={t('pages.home.dataPanel.buttonATPS')}
                url="/data/instruments"
              />
            </Link>
            <Link to="/data/confirm-survey">
              <DataBupCard
                alt="info"
                icon={ClickIcon}
                text={t('pages.home.dataPanel.buttonAnswer')}
                url="/data/confirm-survey"
              />
            </Link>
            <a target="_blank" href={GuiaOrientacion} rel="noreferrer">
              <DataBupCard
                alt="info"
                icon={DownloadIcon}
                text={t('pages.home.dataPanel.resourceButton')}
              />
            </a>
          </Col>
        ) : roleType === PARENT || roleType === STUDENT ? (
          <>
            <Col md={20} xxl={24}>
              <Link to="/data/instruments">
                <DataBupCard
                  alt="info"
                  icon={GroupIcon}
                  text={t('pages.home.dataPanel.buttonATPS')}
                />
              </Link>
              <Link to="/data/confirm-survey">
                <DataBupCard
                  alt="info"
                  icon={ClickIcon}
                  text={t('pages.home.dataPanel.buttonAnswer')}
                />
              </Link>
            </Col>
          </>
        ) : null}
      </Row>
    </div>
  );
};

export default DataBupPanel;
